import { OutletId } from './Outlet';
import { LanguageCode } from './common';

export interface MobilitySolutionId {__mobilitySolutionId: number}

export type MobilitySolutionReference = string;

export default class MobilitySolution {
  id!: MobilitySolutionId;
  outletId!: OutletId;
  description = '';
  reference: MobilitySolutionReference | null = null;
  language: LanguageCode | null = null;
}
